import * as React from "react"
import { Box } from "@mui/material"

import {DATE_PERIODS} from "@constants";
import {DateRangeBlock} from "@components";
import {rangeDatesStockAssDetailsStockEvolution} from "./Ranges";
import {stockAssDetailsEvolutionCurrentPeriod} from "../@signals";


export default function StockAssortmentEvolutionStatusSkuChartToolbar({ dateRange, onChange}) {
    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={stockAssDetailsEvolutionCurrentPeriod.value}
            maxDays={365}
            value={dateRange}
            ranges={rangeDatesStockAssDetailsStockEvolution}
            onChange={onChange}
            onOk = { () => stockAssDetailsEvolutionCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}